export default __webpack_public_path__ + "static/media/flash24.2dc469e3.png";